(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["restock-notify"] && !Shopify.designMode) return;
  try {
    class RestockNotify extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      this.onVariantUpdate = this.onVariantUpdate.bind(this);
      this.onClick = this.onClick.bind(this);
      this.section?.addEventListener('variant:update', this.onVariantUpdate);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.onVariantUpdate);
    }

    // 変種変更時：Horizon がサーバー再描画したセクション HTML から自分自身を取り込む
    onVariantUpdate(event) {
      const html = event.detail && event.detail.data && event.detail.data.html;
      if (!html) return;
      const fresh = html.querySelector('restock-notify');
      if (!fresh) return;
      if (fresh.dataset.productId) this.dataset.productId = fresh.dataset.productId;
      this.dataset.soldout = fresh.dataset.soldout;
      this.innerHTML = fresh.innerHTML;
    }

    onClick(event) {
      const target = event.target;
      if (target.closest('[data-restock-open]')) {
        event.preventDefault();
        this.open();
      } else if (target.closest('[data-restock-close]')) {
        event.preventDefault();
        this.close();
      } else if (target.closest('[data-restock-submit]')) {
        event.preventDefault();
        this.submit();
      }
    }

    open() {
      const modal = this.querySelector('[data-restock-modal]');
      const overlay = this.querySelector('[data-restock-overlay]');
      if (modal) modal.hidden = false;
      if (overlay) overlay.hidden = false;
    }

    close() {
      const modal = this.querySelector('[data-restock-modal]');
      const overlay = this.querySelector('[data-restock-overlay]');
      if (modal) modal.hidden = true;
      if (overlay) overlay.hidden = true;
    }

    submit() {
      const emailEl = this.querySelector('[data-restock-email]');
      const variantEl = this.querySelector('[data-restock-variant]');
      const messageEl = this.querySelector('[data-restock-message]');
      const formEl = this.querySelector('[data-restock-form]');
      const completeEl = this.querySelector('[data-restock-complete]');
      const submitEl = this.querySelector('[data-restock-submit]');

      const email = emailEl ? emailEl.value.trim() : '';
      const variantId = variantEl ? variantEl.value : '';
      const productId = this.dataset.productId;

      if (messageEl) messageEl.textContent = '';

      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        if (messageEl) messageEl.textContent = 'メールアドレスを正しく入力してください。';
        return;
      }
      if (!variantId) {
        if (messageEl) messageEl.textContent = '通知対象のサイズ・カラーを選択してください。';
        return;
      }
      if (typeof BIS === 'undefined' || !BIS.create) {
        if (messageEl) messageEl.textContent = '通知サービスが読み込まれていません。時間をおいて再度お試しください。';
        return;
      }

      if (submitEl) { submitEl.disabled = true; submitEl.classList.add('loading'); }

      BIS.create(email, variantId, productId)
        .then((data) => {
          if (data && data.status === 'OK') {
            if (formEl) formEl.hidden = true;
            if (completeEl) completeEl.hidden = false;
          } else {
            let msg = '登録に失敗しました。時間をおいて再度お試しください。';
            if (data && data.errors) {
              const parts = [];
              for (const key in data.errors) {
                parts.push([].concat(data.errors[key]).join(' '));
              }
              if (parts.length) msg = parts.join(' ');
            } else if (data && data.message) {
              msg = data.message;
            }
            if (messageEl) messageEl.textContent = msg;
          }
        })
        .catch(() => {
          if (messageEl) messageEl.textContent = '通信エラーが発生しました。時間をおいて再度お試しください。';
        })
        .finally(() => {
          if (submitEl) { submitEl.disabled = false; submitEl.classList.remove('loading'); }
        });
    }
  }

  if (!customElements.get('restock-notify')) {
    customElements.define('restock-notify', RestockNotify);
  }
  } catch(e) { console.error(e); }
})();

})();
